import { render, staticRenderFns } from "./ExitLK.vue?vue&type=template&id=63836bae"
import script from "./ExitLK.vue?vue&type=script&lang=js"
export * from "./ExitLK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports